import React from "react";
import { TAP_LINK_STYLE, TAP_INLINE_LINK_STYLE } from "./tapTarget";

/**
 * TextLink — #1163 (D221 G4). A text link that leads somewhere, at least
 * 44px to tap (`tapTarget.js` has the rule and why the drawn text does not
 * move). `as` lets a caller render it as `Link` (react-router); the default
 * is a plain anchor. `inline` is for a link inside a sentence: it stays an
 * inline box (so it wraps with the words) and takes its hit area from
 * padding. Colour, size, weight and underline stay the caller's
 * own, through `style` / `className`: this component only owns the hit area.
 */
export const TextLink = React.forwardRef(function TextLink(
  { children, as: Comp = "a", inline = false, style, ...rest },
  ref
) {
  return (
    <Comp ref={ref} style={{ ...(inline ? TAP_INLINE_LINK_STYLE : TAP_LINK_STYLE), ...style }} {...rest}>
      {children}
    </Comp>
  );
});

export default TextLink;
